import React, { FC, PropsWithChildren, createContext, useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import UserService, { Application } from '../services/UserService'

interface ApplicationsContextType {
  applications: Application[]
  setApplications: any
}

const initialContext: ApplicationsContextType = {
  applications: [],
  setApplications: () => undefined,
}

export const ApplicationsContext = createContext<ApplicationsContextType>(initialContext)

export const useApplications = () => useContext(ApplicationsContext)

const ApplicationsContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [applications, setApplications] = useState<Application[]>([])
  const { org } = useParams()

  useEffect(() => {
    if (!org) return
    UserService.listApplications(org).then((resp) => {
      setApplications(resp)
    })
  }, [org])

  return (
    <ApplicationsContext.Provider value={{ applications, setApplications }}>{children}</ApplicationsContext.Provider>
  )
}

export default ApplicationsContextProvider
